import en from './translations/en.json'
import tr from './translations/tr.json'
import mne from './translations/mne.json'

const resources = {
    en: {
        translation: en,
    },
    tr: {
        translation: tr,
    },
    mne: {
        translation: mne,
    }
}

export default resources